﻿﻿export interface ITicketGroupUserRequest {
    userId: number;
    isPrimary: boolean;
}
